import React, { useState } from 'react';
import useCart from '../../components/hooks/hooks-e-commerce/useCart';
import { useConfirmToast } from '../modules/ConfirmToast';
import './selezioneconfezioni.scss';

const SelezioneConfezioni = ({cartObject, onAggiungiAlCarrello}) => { 
    const { addToCart} = useCart();
    const { showConfirm, ConfirmToastComponent } = useConfirmToast();

    console.log('in Selezione confezione tecnica per vini: ', cartObject);

    const [confezioneSelezionata, setConfezioneSelezionata] = useState(null);
    const [staAggiungendo, setStaAggiungendo] = useState(false);
    const [aggiunto, setAggiunto] = useState(false);
    const [messaggioErrore, setMessaggioErrore] = useState('');
    //console.log('in SelezioneConfezioni.js - cartObject: ', cartObject);
    
    // Calcola lo sconto effettivo
    const getScontoPercentuale = () => {
        if (!cartObject) return 0;
        return parseInt(cartObject.promoValue) || 0;
    }; 

    // Configura confezioni con VALORI SICURI
    const confezioni = React.useMemo(() => {
        //const prezzo = cartObject.prezzo;
        const promo = cartObject.promoValue;
        
        return [
            { 
                id: 1, 
                quantita: 3, 
                label: "Confezione da 3 bottiglie",
                sconto: promo
            },
            { 
                id: 2, 
                quantita: 6, 
                label: "Confezione da 6 bottiglie",
                sconto: promo
            },
            { 
                id: 3, 
                quantita: 12, 
                label: "Confezione da 12 bottiglie",
                sconto: promo
            }
        ];
    }, [cartObject]);

    const calcolaPrezzo = (confezione) => {
        if(cartObject.promoValue) {
            const prezzoTotale = cartObject.prezzo * confezione.quantita;
            const sconto = (prezzoTotale * cartObject.promoValue) / 100;
            return prezzoTotale - sconto;
        } else {
            const prezzoTotale = cartObject.prezzo * confezione.quantita;
            const sconto = 0;
            return prezzoTotale - sconto;
        }
    };

     // Calcola prezzo unitario scontato
    const calcolaPrezzoUnitario = (confezione) => {
        const prezzoTotaleScontato = calcolaPrezzo(confezione);
        return prezzoTotaleScontato / confezione.quantita;
    };

    const handleSelezioneConfezione = (confezione) => {
        setConfezioneSelezionata(confezione);
        setMessaggioErrore('');
    };

    const handleDeseleziona = () => {
        setConfezioneSelezionata(null);
        setMessaggioErrore('');
    };

     // Funzione che esegue l'aggiunta al carrello (logica originale)
    const eseguiAggiunta = async () => {
        if (!confezioneSelezionata || staAggiungendo) return;
        
        setStaAggiungendo(true);
        setMessaggioErrore('');
        
        try {
            // Calcola i prezzi
            const prezzoUnitarioScontato = calcolaPrezzoUnitario(confezioneSelezionata);
            const prezzoFinale = calcolaPrezzo(confezioneSelezionata);
            const scontoPercentuale = getScontoPercentuale();
            const productId = cartObject.idProdotto;

            // Verifica se vigneta esiste
            if (!cartObject.vigneta) {
                console.error('❌ VIGNETA NON TROVATA in cartObject!');
                console.error('   Chiavi disponibili:', Object.keys(cartObject || {}));
            }

            // Payload per quantita
            const itemData = {
                productId: productId,
                
                // QUANTITÀ: usa "quantity" che è ciò che il server cerca
                quantity: confezioneSelezionata.quantita, 
                quantita: confezioneSelezionata.quantita, 
                
                // Prezzi
                prezzoUnitario: parseFloat(prezzoUnitarioScontato.toFixed(2)),
                prezzoFinale: parseFloat(prezzoFinale.toFixed(2)),
                
                // Dati extra
                nome_vino: cartObject.nome_vino,
                vigneta: String(cartObject.vigneta || ''), 
                img_cartart: String(cartObject.vigneta || ''),
                scontoApplicato: scontoPercentuale,

                // DEBUG
                /* debug_vigneta: {
                    value: cartObject.vigneta,
                    type: typeof cartObject.vigneta,
                    is_string: typeof cartObject.vigneta === 'string',
                    length: cartObject.vigneta?.length
                }, */

                // ✅ AGGIUNGI QUESTI 3 CAMP (sono quelli che mancano!)
                packaging_cost: confezioneSelezionata.quantita === 3 ? 1.50 : confezioneSelezionata.quantita === 6 ? 2.50 : confezioneSelezionata.quantita === 12 ? 4.00 : 0,
                packaging_description: `Confezione da ${confezioneSelezionata.quantita} bottiglie`,
                packaging_combo: [confezioneSelezionata.quantita],

               // Dati confezione (per debug)
                confezione: {
                    id: confezioneSelezionata.id,
                    label: confezioneSelezionata.label,
                    quantita: confezioneSelezionata.quantita
                }
            };

            /*
            * debug 09-04-26
            */
            console.log('🔍 FASE 1 - itemData inviato a addToCart:', {
                packaging_cost: itemData.packaging_cost,
                packaging_description: itemData.packaging_description,
                packaging_combo: itemData.packaging_combo
            });

            // Usa l'hook
            const result = await addToCart(itemData);
            
            if (result.success) {
                console.log('✅ Successo! Carrello:', result.cart);
                setAggiunto(true);
                
                setTimeout(() => {
                    setAggiunto(false);
                    setConfezioneSelezionata(null);
                }, 2000);
                
            } else {
                setMessaggioErrore(result.error || 'Errore sconosciuto');
            }
            
        } catch (errore) {
            console.error('Errore:', errore);
            setMessaggioErrore('Errore di connessione al server');
        } finally {
            setStaAggiungendo(false);
        }
    };

    // Nuova funzione che mostra il toast prima di aggiungere
    const handleAggiungiAlCarrello = async () => {
        if (!confezioneSelezionata || staAggiungendo) return;
        
        // Mostra toast di conferma
        const confirmed = await showConfirm(
            `Aggiungere <strong>${confezioneSelezionata.quantita}</strong> bottiglie di <strong>${cartObject.nome_vino}</strong> al carrello?`
        );
        
        // Solo se confermato, procedi con l'aggiunta
        if (confirmed) {
            await eseguiAggiunta();
        }
    };

    
    // Calcola prezzo per visualizzazione
    const getPrezzoVisualizzazione = (confezione) => {
        if(cartObject.promoValue) {
            const prezzoOriginale = (cartObject.prezzo * confezione.quantita).toFixed(2);
            console.log('SelezioneConfezioni- prezzoOriginale: ', prezzoOriginale);
            const prezzoScontato = calcolaPrezzo(confezione).toFixed(2);
            console.log('SelezioneConfezioni - prezzoScontat: ', prezzoScontato);
            const risparmio = (cartObject.prezzo * confezione.quantita - calcolaPrezzo(confezione)).toFixed(2);
            console.log('SelezioneConfezioni - risparmio: ', risparmio);
            return { prezzoOriginale, prezzoScontato, risparmio };
        } else {
            const prezzoOriginale = (cartObject.prezzo * confezione.quantita).toFixed(2);
            const prezzoScontato = calcolaPrezzo(confezione).toFixed(2);
            const risparmio = 0;
            return { prezzoOriginale, prezzoScontato, risparmio };
        }
    };

    return (
        <div className="selezione-confezioni">
            {/* Toast di conferma */}
            <ConfirmToastComponent />
            {messaggioErrore && (
                <div className="messaggio-errore">
                    ❌ {messaggioErrore}
                </div>
            )}
            <div className="lista-confezioni">
                {confezioni.map((confezione) => {
                    const prezzi = getPrezzoVisualizzazione(confezione);
                    
                    return (
                        <button 
                            key={confezione.id} 
                            className={`bottone-confezione ${confezioneSelezionata?.id === confezione.id ? 'selezionata' : ''}`}
                            onClick={() => handleSelezioneConfezione(confezione)}
                            disabled={staAggiungendo}
                        >    
                            <div className="info-confezione"> 
                                <span className="label-confezione">{confezione.label}</span>
                                {confezione.sconto > 0 && <div className="confezione__scontata">
                                    <span className="badge-sconto">-{confezione.sconto}%</span>
                                    <span className="prezzo-originale"><s>€{prezzi.prezzoOriginale}</s></span>
                                </div>}    
                            </div>
                            
                            {(confezione.sconto > 0) ? <div className="prezzo-confezione">
                                <div className="prezzi-stack">
                                    <span className="prezzo-finale">
                                        € {prezzi.prezzoScontato}
                                    </span>
                                </div>
                                <div className="risparmio-info">
                                    Risparmio: {prezzi.risparmio} €
                                </div>
                            </div>
                            :
                            <div className="prezzo-confezione">
                                <div className="prezzi-stack">
                                    <span className="prezzo-originale">
                                        € {prezzi.prezzoScontato}
                                    </span>
                                </div>
                            </div>}
                        </button>
                    );
                })}
            </div>

            <button className={`bottone-aggiungi-carrello ${staAggiungendo ? 'aggiungendo' :  ''}
                ${aggiunto ? 'aggiunto' : ''} ${!confezioneSelezionata ? 'disabilitato' : '' }`}
                    onClick={handleAggiungiAlCarrello}
                    disabled={!confezioneSelezionata || staAggiungendo} >    
                <span className="testo-bottone">
                    {!confezioneSelezionata 
                        ? 'Seleziona una confezione' 
                        : staAggiungendo 
                        ? 'Aggiungendo...' 
                        : aggiunto 
                            ? 'Aggiunto!' 
                            : `Aggiungi ${confezioneSelezionata.quantita} unità al Carrello`
                    }
                </span>    
                {staAggiungendo && <span className="effetto-pulsazione"></span>}
                {staAggiungendo && <span className="barra-progresso"></span>}
            </button>        
                    
            {confezioneSelezionata && (
            <div className="riepilogo-selezione">
                <p><strong>Selezionato: </strong>{confezioneSelezionata.label} •
                    {confezioneSelezionata.sconto > 0 && (       
                    <span className="testo-sconto"> Sconto {confezioneSelezionata.sconto}% applicato</span> )}    
                </p>
                <button className="bottone-deseleziona" onClick={handleDeseleziona} disabled={staAggiungendo}>
                    <span className="icona-deseleziona">✕ Cambia Confezione</span>
                </button>    
            </div>)}
        </div>
    );
};
export default SelezioneConfezioni;
